import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'banner',
  name: '轮播图',
  icon: '图',
  group: '营销组件',
  description: '轮播展示图片、标题和跳转入口',
  defaultProps: {
    items: [],
    autoplay: true,
    interval: 5000,
    indicator: true
  }
}
